export const PROJECTED_RETURN_CONFIG = {
	plotOptions: {
		spline: {
			marker: {
				enabled: false
			},
			areaspline: {
				marker: {
					enabled: false
				},
				stacking: 'normal'
			},
			states: {
				inactive: {
					enabled: false
				},
				hover: {
					lineWidthPlus: 0,
					halo: {
						size: 0
					}
				}
			},
			series: {
				lineWidth: 3
			}
		},
		areasplinerange: {
			lineWidth: 0,
			marker: {
				enabled: false,
				states: {
					hover: {
						enabled: false
					}
				}
			},
			states: {
				inactive: {
					enabled: false
				},
				hover: {
					enabled: false
				}
			}
		}
	},
	xAxis: {
		tickLength: 0,
		labels: {
			style: {
				fontSize: '8px'
			},
			formatter: function (): any {
				if (this.isFirst) {
					return 'Today';
				}
				if (this.isLast) {
					return '10 Years';
				}
			}
		},
		// This empty object is necessary for the crosshair to appear
		crosshair: {
		}
	},
	yAxis: {
		labels: {
			style: {
				fontSize: '8px'
			},
			formatter: function (): any {
				return this.value + '%';
			}
		},
		title: undefined
	},
	legend: {
		enabled: false
	},
	chart: {
		marginTop: 5,
		style: {
			fontFamily: 'FortBook, Arial, sans-serif',
			color: '#616161',
			fontSize: '8px'
		},
		type: 'areasplinerange'
	}
};
